module.exports = __webpack_public_path__ + "media/images/dummy_item2-28c24041b96d5ef7738eb20ed7434fd5.jpeg";